import { render, staticRenderFns } from "./appServiceOpen.vue?vue&type=template&id=60e59fe8&scoped=true&"
import script from "./appServiceOpen.vue?vue&type=script&lang=js&"
export * from "./appServiceOpen.vue?vue&type=script&lang=js&"
import style0 from "./appServiceOpen.vue?vue&type=style&index=0&id=60e59fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e59fe8",
  null
  
)

export default component.exports